import MuiStep, { StepProps } from '@mui/material/Step';

const EDStep = (props: StepProps) => {
  return <MuiStep {...props} />;
};

export default EDStep;
